import { preAlertLogApis } from '@apis/preAlertLogApis';
import { useQuery } from '@hooks/useQuery';
import { PreAlertLog } from '@models/PreAlertLog';

export const usePreAlertLog = (id: number) => {
  return useQuery([`/dashboard/pre-alert-log/${id}/`], async () => {
    let hasNext = true;
    let page = 1;
    let results: PreAlertLog[] = [];
    while (hasNext) {
      const result = await preAlertLogApis
        .get('/dashboard/pre-alert-log/{id}/', {
          path: { id },
          query: { page },
        })
        .then((r) => r[200]!);
      hasNext = !!result.next;
      page++;
      results.push(...result.results);
    }
    return results;
  });
};
